<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div id="customercenter-magazine">

	<div class="inner-wrap">

	  <ul class="magazine-tab">
	    <li class="nav-item"><a routerLink="/customerCenter/magazine" class="nav-link active">협회지</a></li>
	    <li class="nav-item"><a routerLink="/customerCenter/magazine/subscription" class="nav-link">정기구독안내</a></li>
	  </ul>

	  <div class="tab-content">
		  <div class="txt">
		    <p>우리 협회에서</p>
		        월간으로 발생하고 있는 "냉동공조"지는 국내 냉난방공조업계의 소식을 전하는 매체입니다.<br/>
		    "냉동공조"지는 보다 알찬 내용과 정확한 정보의 제공으로 독자의 요구에 부응하기 위해 최선을 다하고 있습니다.
		  </div>
		  <ul class="magazine">
		    <li *ngFor='let item of magazineList'>
		      <a class="img cp" (click)="openMagazine(item)">
		        <img src="{{baseURL + item.file_name1}}" alt="협회지" />
		        <div class="img-hover">목차보기</div>
		      </a>
		      <div class="ym">{{item.title}}</div>
		    </li>
		  </ul>
		  <div class="pagination-area">
		    <ngb-pagination
		      [(page)]="params.no"
		      [pageSize]="6"
          [maxSize]="maxSize"
		      [collectionSize]="totalCount"
		      [boundaryLinks]="true"
          (pageChange)="loadPage($event)"
		      >
		      <ng-template ngbPaginationFirst>&lt;&lt;</ng-template>
		      <ng-template ngbPaginationLast>&gt;&gt;</ng-template>
		      <ng-template ngbPaginationPrevious>&lt;</ng-template>
		      <ng-template ngbPaginationNext>&gt;</ng-template>
		    </ngb-pagination>
		  </div>
	  </div>
	</div>
</div>

<app-footer></app-footer>